/*
| Mega menu — desktop panels, carousels, mobile accordion
*/

const CLOSE_DELAY = 0
const SLIDE_INTERVAL = 5000
const SWIPE_THRESHOLD = 50

function bindCarouselSwipe(surface, { onNext, onPrev, onStart, onEnd }) {
  let start = null
  let suppressClick = false
  let activePointerId = null

  const cleanupDocumentListeners = () => {
    document.removeEventListener('pointermove', onPointerMove)
    document.removeEventListener('pointerup', onPointerUp)
    document.removeEventListener('pointercancel', onPointerUp)
    surface.classList.remove('is-dragging')
  }

  const finish = (clientX, clientY) => {
    if (!start) return

    const deltaX = clientX - start.x
    const deltaY = clientY - start.y

    if (Math.abs(deltaX) >= SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
      suppressClick = true

      if (deltaX < 0) {
        onNext()
      } else {
        onPrev()
      }
    }

    start = null
    activePointerId = null
    cleanupDocumentListeners()
    onEnd?.()
  }

  const onPointerMove = (event) => {
    if (!start || event.pointerId !== activePointerId) return

    const deltaX = Math.abs(event.clientX - start.x)
    const deltaY = Math.abs(event.clientY - start.y)

    if (deltaX > 8 && deltaX > deltaY) {
      surface.classList.add('is-dragging')
    }
  }

  const onPointerUp = (event) => {
    if (!start || event.pointerId !== activePointerId) return

    try {
      if (surface.hasPointerCapture(event.pointerId)) {
        surface.releasePointerCapture(event.pointerId)
      }
    } catch (_) {
      /* ignore */
    }

    finish(event.clientX, event.clientY)
  }

  surface.addEventListener('pointerdown', (event) => {
    if (event.target.closest('[data-mega-dot]')) return
    if (event.pointerType === 'mouse' && event.button !== 0) return

    event.preventDefault()

    start = { x: event.clientX, y: event.clientY }
    suppressClick = false
    activePointerId = event.pointerId
    onStart?.()

    try {
      surface.setPointerCapture(event.pointerId)
    } catch (_) {
      /* ignore */
    }

    document.addEventListener('pointermove', onPointerMove)
    document.addEventListener('pointerup', onPointerUp)
    document.addEventListener('pointercancel', onPointerUp)
  })

  surface.addEventListener('click', (event) => {
    if (!suppressClick) return

    event.preventDefault()
    suppressClick = false
  })

  surface.addEventListener('dragstart', (event) => {
    event.preventDefault()
  })
}

function initDesktopPanels() {
  const header = document.querySelector('[data-header-container-el]')
  const triggers = document.querySelectorAll('[data-mega-trigger]')
  const panels = document.querySelectorAll('[data-mega-panel]')
  const backdrop = header?.querySelector('[data-mega-backdrop]')

  if (!header || !triggers.length) return

  let closeTimer

  const closeAll = () => {
    panels.forEach((panel) => panel.classList.remove('is-open'))
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'))

    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'true')
    }
  }

  const cancelClose = () => clearTimeout(closeTimer)

  const scheduleClose = () => {
    cancelClose()
    closeTimer = setTimeout(closeAll, CLOSE_DELAY)
  }

  const open = (key) => {
    cancelClose()
    closeAll()

    const panel = document.querySelector(`[data-mega-panel="${key}"]`)
    const trigger = document.querySelector(`[data-mega-trigger="${key}"]`)

    if (!panel || !trigger) return

    panel.classList.add('is-open')
    trigger.setAttribute('aria-expanded', 'true')

    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'false')
    }
  }

  triggers.forEach((trigger) => {
    const key = trigger.getAttribute('data-mega-trigger')

    trigger.addEventListener('mouseenter', () => open(key))
    trigger.addEventListener('focus', () => open(key))
  })

  header.querySelectorAll('.hd-Banner_Nav .hd-Banner_Link:not([data-mega-trigger])').forEach((link) => {
    link.addEventListener('mouseenter', closeAll)
    link.addEventListener('focus', closeAll)
  })

  header.addEventListener('mouseenter', cancelClose)
  header.addEventListener('mouseleave', scheduleClose)

  panels.forEach((panel) => {
    panel.addEventListener('mouseenter', cancelClose)
    panel.addEventListener('mouseleave', scheduleClose)
  })

  backdrop?.addEventListener('click', closeAll)
  backdrop?.addEventListener('mouseenter', scheduleClose)

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll()
  })
}

function initCarousels() {
  document.querySelectorAll('[data-mega-carousel]').forEach((carousel) => {
    const featured = carousel.closest('[data-mega-featured]')
    const slides = Array.from(carousel.querySelectorAll('[data-mega-slide]'))
    const dots = featured
      ? Array.from(featured.querySelectorAll('[data-mega-dot]'))
      : []
    const kicker = featured?.querySelector('.hd-Mega_FeaturedKicker')
    const copy = featured?.querySelector('.hd-Mega_FeaturedText')

    if (slides.length === 0) return

    let current = 0
    let timer

    const show = (index) => {
      current = (index + slides.length) % slides.length
      const slide = slides[current]

      slides.forEach((item, i) => item.classList.toggle('is-active', i === current))
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current))

      if (kicker && slide.dataset.megaKicker) {
        kicker.textContent = slide.dataset.megaKicker
      }

      if (copy && slide.dataset.megaText) {
        copy.textContent = slide.dataset.megaText
      }

      if (featured && slide.dataset.megaUrl) {
        featured.setAttribute('href', slide.dataset.megaUrl)
      }
    }

    const start = () => {
      if (slides.length < 2) return

      stop()
      timer = window.setInterval(() => show(current + 1), SLIDE_INTERVAL)
    }

    const stop = () => {
      if (timer) {
        window.clearInterval(timer)
        timer = null
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        show(index)
        start()
      })
    })

    if (slides.length >= 2) {
      bindCarouselSwipe(featured || carousel, {
        onNext: () => {
          show(current + 1)
          start()
        },
        onPrev: () => {
          show(current - 1)
          start()
        },
        onStart: stop,
        onEnd: start
      })
    }

    carousel.querySelectorAll('img').forEach((image) => {
      image.setAttribute('draggable', 'false')
    })

    show(0)
    start()
  })
}

function initMobileAccordion() {
  document.querySelectorAll('[data-mega-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const category = trigger.closest('[data-mega-cat]')

      if (!category) return

      category.classList.toggle('is-open')
      trigger.setAttribute('aria-expanded', category.classList.contains('is-open') ? 'true' : 'false')
    })
  })
}

function initMobileTabs() {
  document.querySelectorAll('[data-mega-mobile]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-mega-tab]'))
    const depts = Array.from(root.querySelectorAll('[data-mega-dept]'))
    const media = Array.from(root.querySelectorAll('[data-mega-media]'))

    if (tabs.length < 2) return

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.megaTab

        tabs.forEach((item) => item.classList.toggle('is-active', item === tab))
        depts.forEach((dept) => dept.classList.toggle('is-active', dept.dataset.megaDept === key))
        media.forEach((item) => item.classList.toggle('is-active', item.dataset.megaMedia === key))
      })
    })
  })
}

function initSearchTriggers() {
  const openHeaderSearch = () => {
    const detailsModal = document.querySelector('[data-header-search] details-modal')

    if (detailsModal?.openFromTrigger) {
      detailsModal.openFromTrigger()
      return
    }

    document.querySelector('[data-header-search] .header__search__inner summary')?.click()
  }

  document.querySelectorAll('[data-header-search-trigger], [data-drawer-search-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()

      const detailsModal = document.querySelector('[data-header-search] details-modal')

      if (!detailsModal) {
        const fallback = trigger.dataset.searchFallback

        if (fallback) window.location.href = fallback

        return
      }

      if (window.drawers?.activeDrawerKey) {
        window.drawers.activeDrawerKey = ''
      }

      window.requestAnimationFrame(openHeaderSearch)
    })
  })
}

function init() {
  initDesktopPanels()
  initCarousels()
  initMobileAccordion()
  initMobileTabs()
  initSearchTriggers()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
